import type { WidgetSettings } from '../typings/configuration.types';
import { COUNTRY_CODE } from '../typings/countries';

type SettingsWithOptionalDefaults = Omit<WidgetSettings, 'apiBasePath' | 'locale'> & {
    apiBasePath?: string;
    locale?: COUNTRY_CODE;
};

export default class SettingsHelper {
    static initializeApiBasePathAndLocale(settings: SettingsWithOptionalDefaults): void {
        if (!settings.apiBasePath) {
            const host = window.location.hostname;
            if (host === 'localhost' || host.endsWith('localhost')) {
                settings.apiBasePath = 'https://checkout.mm.localhost';
            } else {
                settings.apiBasePath = 'https://checkout.staging.musicmagpie.co.uk';
            }
        }

        // We can pass locale from outside into widget, but if it was missed, then we set it by apiBasePath
        if (settings.locale) {
            settings.locale = settings.apiBasePath.includes('decluttr') ? COUNTRY_CODE.US : COUNTRY_CODE.GB;
        }
    }
}
